module.exports = __webpack_public_path__ + "126ed5b3e87d078aa5786dc42de55044.svg";